import React, { useState } from 'react';
import { clientLink } from '../../utils/links';
import { fetchAccessToken } from '../../utils/accessToken';

/**
 * Copies a project's secure client link straight from the projects list, so
 * staff do not have to open the project first. The token is fetched only when
 * the action is used, and never displayed.
 */
export function CopyClientLink({
  slug,
  projectId
}: {
  slug: string;
  projectId: string;
}) {
  const [state, setState] = useState<'idle' | 'busy' | 'done' | 'failed'>('idle');
  async function copy() {
    setState('busy');
    const token = await fetchAccessToken(slug, projectId);
    const link = clientLink(slug, token);
    if (!link) {
      setState('failed');
      window.setTimeout(() => setState('idle'), 2200);
      return;
    }
    try {
      await navigator.clipboard.writeText(link);
    } catch {
      /* Clipboard unavailable — nothing else to fall back to from a list row. */
      setState('failed');
      window.setTimeout(() => setState('idle'), 2200);
      return;
    }
    setState('done');
    window.setTimeout(() => setState('idle'), 1800);
  }
  return <button type="button" onClick={copy} className="label-sm whitespace-nowrap text-paper/30 underline underline-offset-4 transition-colors duration-150 ease-out hover:text-paper/70" data-id="element-182" data-mp="1ukvg2x1agml6">
      {state === 'done' ? 'Link copied ✓' : state === 'failed' ? 'Link unavailable' : state === 'busy' ? 'Copying…' : 'Copy client link'}
    </button>;
}